import React from 'react'
import { useTranslation } from 'react-i18next'

// constants
import { SITE_ID } from '../../../constants'
import { PaymentMPProductSKU } from '../../../constants/payment-mp-product-sku'
import features from '../../../constants/features-per-country'

// images
import nulingaLogo from '../../../assets/images/products/products-logos/nulinga.svg'

// eslint-disable-next-line prettier/prettier
const showProductNulinga = features[SITE_ID || 'BMAR']?.products?.nulinga?.marketplace

export function useProducts(isUserLoggedIn) {
  const { t } = useTranslation()

  const urlCurriculum = () => {
    return isUserLoggedIn ? '/candidatos/curriculum' : '/login?returnTo=/postulantes/productos'
  }

  const productsMarketplace = [
    {
      key: 'Nulinga',
      enabled: showProductNulinga,
      logo: nulingaLogo,
      title: t('products.products.nulinga.title'),
      body: t('products.products.nulinga.body'),
      price: '',
      href: 'productos/nulinga',
      alt: 'Logo Nulinga',
      hrefText: t('products.products.nulinga.cta'),
      sku: PaymentMPProductSKU.NULINGA,
      acquiredText: t('products.products.nulinga.acquiredText'),
      acquiredHref: urlCurriculum(),
    },
  ]

  return productsMarketplace.filter(product => product.enabled)
}
